import React from 'react';
import EcosystemHero from '../components/EcosystemHero';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const EcosystemPage = () => {
  const stats = [
    { label: "Uptime", value: "99.99%", sub: "Enterprise Grade", icon: FiIcons.FiCloudLightning, color: "emerald" },
    { label: "Currencies", value: "135+", sub: "Global Reach", icon: FiIcons.FiGlobe, color: "blue" },
    { label: "Integrations", value: "1,000+", sub: "Via Nima Engine", icon: FiIcons.FiLayers, color: "indigo" },
    { label: "Cost Savings", value: "85%", sub: "Vs Competitors", icon: FiIcons.FiTrendingDown, color: "violet" }
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <main>
        <EcosystemHero />
        <div className="py-24 bg-slate-950 overflow-hidden relative">
          <div className="absolute inset-0 opacity-[0.15]" style={{ backgroundImage: 'radial-gradient(#4f46e5 1px, transparent 1px)', backgroundSize: '40px 40px' }} />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {stats.map((stat, i) => (
                <motion.div key={i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1, duration: 0.5, ease: "easeOut" }} animate={{ y: [0, -12, 0] }} whileHover={{ scale: 1.05 }} style={{ transition: { y: { duration: 4 + (i * 0.5), repeat: Infinity, ease: "easeInOut" } } }} className="relative group" >
                  <div className={`absolute -inset-0.5 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-3xl blur opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200`} />
                  <div className="relative flex flex-col items-center text-center p-8 bg-slate-900/80 backdrop-blur-xl border border-white/10 rounded-3xl h-full shadow-2xl">
                    <div className={`mb-6 p-4 rounded-2xl bg-slate-800/50 text-indigo-400 group-hover:scale-110 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-500`}>
                      <SafeIcon icon={stat.icon} className="w-8 h-8" />
                    </div>
                    <h3 className="text-4xl font-black text-white mb-2 tracking-tighter"> {stat.value} </h3>
                    <div className="flex flex-col gap-1">
                      <p className="text-indigo-400 text-[10px] font-black uppercase tracking-[0.2em]"> {stat.label} </p>
                      <p className="text-slate-500 text-[10px] uppercase font-bold tracking-wider"> {stat.sub} </p>
                    </div>
                    <div className="mt-6 w-12 h-1 bg-gradient-to-r from-indigo-500 to-transparent rounded-full opacity-30 group-hover:w-full transition-all duration-700" />
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
        <section className="py-24 bg-slate-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-[3rem] p-12 border border-slate-200 shadow-xl overflow-hidden relative">
              <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-50 rounded-full -translate-y-1/2 translate-x-1/2 blur-3xl" />
              <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="text-4xl font-black text-slate-900 mb-6 tracking-tight leading-tight"> See how it all <br /> <span className="text-indigo-600">Connects together.</span> </h2>
                  <p className="text-lg text-slate-500 mb-8 font-medium"> We've built more than just tools; we've built a lifecycle. Discover the sequential flow of an event from planning to global distribution. </p>
                  <Link to="/roadmap" className="inline-flex items-center gap-3 px-8 py-4 bg-slate-900 text-white rounded-full font-bold hover:shadow-2xl hover:-translate-y-1 transition-all" > View Interaction Flow <SafeIcon icon={FiIcons.FiArrowRight} /> </Link>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  {[ { icon: FiIcons.FiNavigation, label: "Pilot" }, { icon: FiIcons.FiZap, label: "Bifrost" }, { icon: FiIcons.FiCpu, label: "Scotty" }, { icon: FiIcons.FiShoppingCart, label: "Commerce" } ].map((item, i) => (
                    <div key={i} className="p-6 bg-slate-50 rounded-3xl border border-slate-100 flex flex-col items-center text-center">
                      <SafeIcon icon={item.icon} className="w-8 h-8 text-indigo-600 mb-2" />
                      <span className="text-[10px] font-black uppercase tracking-widest text-slate-400">{item.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default EcosystemPage;